import React from 'react';
import { ButtonV2, ButtonV2Props } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { ShopRootExpertsExploreCurationClicked } from '@apps/registry/common/components/Catalog/Catalog.telemetry.types';

interface CurationCtaProps extends ButtonV2Props {
  method: ShopRootExpertsExploreCurationClicked['method'];
}

const CurationCta = (props: CurationCtaProps) => {
  const { method, ...restProps } = props;
  const { t } = useTranslation('catalogRegistry');
  const { billboard } = t('curationHeroHeader');

  return (
    <ButtonV2
      variant="outline"
      borderColor="white"
      data-method={method}
      {...restProps}
    >
      {billboard.exploreButton()}
    </ButtonV2>
  );
};
export { CurationCta };
